export enum CirclePointTypeEnum {
  ACTIVE,
  OFF,
  OK,
}
